import { Heading, Spinner, Stack } from '@drycut/ui-components';

export function PageLoading(): React.ReactElement {
  return (
    <Stack direction="row" className="justify-center gap-3">
      <Spinner className="text-zinc-400" />
      <Heading variant="h3" className="font-aribau text-2xl text-zinc-400">
        Loading...
      </Heading>
    </Stack>
  );
}
